<template>
  <div class="m-logout">
    <AtomLoadingPrimary :loading-text="$t('mLogout.message')"/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeLogout'
}
</script>
